import {
  Flex,
  List,
  Paper,
  Title,
  Text,
  Button,
  Avatar,
  Affix,
  Image,
} from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { usePOAStepsStore } from "../../../hooks/ui/poaStepsDataStore";
import {
  ArrowUpOnSquareStackIcon,
  ChartBarIcon,
  ChartPieIcon,
} from "@heroicons/react/24/solid";
import FullmaktskollenImage from "/fullmaktskollen-logo.png";

export default function POAInfo() {
  const { nextStep, prevStep } = usePOAStepsStore();
  return (
    <>
      <Flex justify="center" align="center" mt={"2rem"} px={"xl"}>
        <Flex direction="column" maw={672} w={"100%"}>
          <Title
            order={2}
            mb="2rem"
            ff={"var(--wallet-font-family-subjecttivity)"}
          >
            Vi behöver en fullmakt för att hämta information om din pension.
          </Title>
          <Text mb={"lg"}>
            Fullmakten hämtas in via via Fullmaktskollen, en tjänst som är
            framtagen i samarbete med Pensionsmyndigheten. Informationen kommer
            ligga till grund för din personliga rådgivning.
          </Text>
          <Paper p={30} radius={"24px"} mb={"2rem"}>
            <List spacing="xs" size="sm">
              <List.Item
                icon={
                  <Avatar>
                    <ChartPieIcon
                      height={"26px"}
                      color="var(--wallet-color-sambla-green-shade-700)"
                    />
                  </Avatar>
                }
              >
                Vi hämtar information om dina befintliga pensionsförsäkringar
              </List.Item>
              <List.Item
                icon={
                  <Avatar>
                    {" "}
                    <ChartBarIcon
                      height={"26px"}
                      color="var(--wallet-color-sambla-green-shade-700)"
                    />
                  </Avatar>
                }
              >
                Vi analyserar och tar fram personliga råd för att förbättra din
                pension
              </List.Item>
              <List.Item
                icon={
                  <Avatar>
                    <ArrowUpOnSquareStackIcon
                      height={"26px"}
                      color="var(--wallet-color-sambla-red-shade-600)"
                    />
                  </Avatar>
                }
              >
                Vi kommer INTE flytta eller ändra dina försäkringar.
              </List.Item>
            </List>
          </Paper>
          <Paper p={30} radius={"24px"} mb="2rem">
            <Title
              order={5}
              style={{ color: "var(--wallet-color-sambla-green-shade-700)" }}
              mb={"1rem"}
            >
              <FormattedMessage
                id="poaInfo.poaCard.sectionOne.title"
                defaultMessage="What is a power of attorney?"
              />
            </Title>
            <Text mb={"1rem"}>
              <FormattedMessage
                id="poaInfo.poaCard.sectionOne.paragraph"
                defaultMessage="A power of attorney gives a specifically designated person or company (the attorney-in-fact) the authority to perform actions on behalf of someone else (the principal)."
              />
            </Text>
            <Title
              order={5}
              style={{ color: "var(--wallet-color-sambla-green-shade-700)" }}
              mb={"1rem"}
            >
              <FormattedMessage
                id="poaInfo.poaCard.sectionTwo.title"
                defaultMessage="What is a power of attorney and how do I revoke it?"
              />
            </Title>
            <Text mb={"1rem"}>
              <FormattedMessage
                id="poaInfo.poaCard.sectionTwo.paragraph"
                defaultMessage="A power of attorney for information is a limited power of attorney that grants the attorney-in-fact the right to receive specific information about insurance and pensions, for example from an insurance company. This power of attorney can be time-limited or valid indefinitely. You can revoke this power of attorney at any time. If the power of attorney is registered on fullmaktskollen.se, you can easily modify or revoke it there. For more information, visit www.fullmaktskollen.se."
              />
            </Text>
            <Title
              order={5}
              style={{ color: "var(--wallet-color-sambla-green-shade-700)" }}
              mb={"1rem"}
            >
              <FormattedMessage
                id="poaInfo.poaCard.sectionThree.title"
                defaultMessage="What is Fullmaktskollen?"
              />
            </Title>
            <Text mb={"1rem"}>
              <FormattedMessage
                id="poaInfo.poaCard.sectionThree.paragraph"
                defaultMessage="Fullmaktskollen.se is a service for managing powers of attorney in the life and pension sector. Fullmaktskollen.se makes it easy for individuals and companies to get an overview of their powers of attorney and how long they are valid. The service also allows you to sign and revoke powers of attorney."
              />
            </Text>
          </Paper>
          <Paper p={"lg"} radius={"24px"} mb={"xl"}>
            <Flex justify={"center"}>
              <Image
                src={FullmaktskollenImage}
                alt="Fullmaktskollen"
                h={38}
                w="auto"
                fit="contain"
              />
            </Flex>
          </Paper>

          <Affix position={{ bottom: 0 }} bg={"white"} w={"100vw"} p={"lg"}>
            <Flex justify={"center"} gap="md">
              <Button onClick={() => prevStep()} variant="outline">
                Tillbaka
              </Button>
              <Button onClick={() => nextStep()}>Nästa</Button>
            </Flex>
          </Affix>
        </Flex>
      </Flex>
    </>
  );
}
